import { useContext } from 'react';

import { CategoricalBarChartTicks } from '../contexts/CategoricalBarChartValueTicks.context.js';

export const useCategoricalBarChartTicks = () => {
  const context = useContext(CategoricalBarChartTicks);

  if (context === undefined) {
    throw new Error(
      'useCategoricalBarChartTicks must be used within a CategoricalBarChartTicks',
    );
  }

  return context;
};
